import { createContext, useContext, useState } from 'react';

const CustomerGroupContext = createContext([null, () => {}]);

export function CustomerGroupProvider({ children }) {
	const [customerGroup, setCustomerGroup] = useState(null);

	return (
		<CustomerGroupContext.Provider
			value={[customerGroup, setCustomerGroup]}
		>
			{children}
		</CustomerGroupContext.Provider>
	);
}

export const useCustomerGroup = () => useContext(CustomerGroupContext);
